export const ReviewPromptCompletionReasonEnum = Object.freeze({
	LOW_EXPERIENCE_SCORE: "low_experience_score",
	PRIVATE_FEEDBACK_SUBMITTED: "private_feedback_submitted",
	PUBLIC_REVIEW_COMPLETED: "public_review_completed",
	NEVER_ASK_AGAIN: "never_ask_again",
})
